import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from "react-router-dom"
import HOC from "./HOC"
import { BiDotsVerticalRounded } from "react-icons/bi";
import BaseUrl from "../BaseUrl";
import axios from 'axios'
import { Menu } from '@headlessui/react'
import swal from "sweetalert";
import { getAuthConfig, getApiErrorMessage } from '../services/auth';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const GoalListByCompany = () => {
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [goaldata, setGoalData] = useState([]);
    const location = useLocation()


    const getGoalList = async () => {
        const token = localStorage.getItem("authorization");
        var auth = {
            headers: {
                Authorization: `bearer ${token}`,
                
            },
        };
      
        const url = `${BaseUrl()}api/user/goal/list/by_company`;
        const body = {
            userId: location.state.id,
        };
        console.log("userBody",body)
        console.log("Auth", auth);
      
        try {
            const res = await axios.post(url, body,auth );
            console.log("goalRes", res);
            if (res.data.ResponseCode === 200) {
                setGoalData(res.data.Response.allgoal);
            }
        } catch (error) {
            console.log(error);
        }
    };
    


    useEffect(() => {
        getGoalList();
    }, []);


    const ViewGoal = async (row) => {
        try {
            navigate('/my-goal', {
                state: {
                    data: row.id
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

   


    const updateGoalName = async (row) => {
        const token = localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            }
        };
        swal("Enter a new goal name:", {
            content: "input",
        })
            .then(async (value) => {
                const url = BaseUrl() + `api/goal/update-goal-name/${row.id}`;
                const data = {
                    name: value
                }
                const res = await axios.post(url, data, auth);
                if (res.data.ResponseCode === 200) {
                    getGoalList()
                    swal("Goal updated successfully", {
                        icon: "success"
                    });
                } else {
                    swal(res.data.ResponseMessage, {
                        button: false
                    });
                }
            })
    };



    const deleteGoal = async (row) => {
        swal({
            title: "Delete goal?",
            text: "This action cannot be undone.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                const url = `${BaseUrl()}api/goal/delete-goal/${row.id}`;
                try {
                    const res = await axios.post(url, null, getAuthConfig());
                    if (res.status === 200) {
                        getGoalList();
                        swal("Goal deleted successfully", {
                            icon: "success",
                        });
                    } else {
                        swal(res.data.ResponseMessage, {
                            button: false,
                        });
                    }
                } catch (error) {
                    swal(error.friendlyMessage || getApiErrorMessage(error), {
                        icon: "error",
                        button: false,
                    });
                }
            }
        });
    }
    

    const getMyUser = async () => {
        const token = localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            }
        };
        const url = `${BaseUrl()}api/user/user_list`;
        try {
            const res = await axios.get(url, auth);
            if (res.data.ResponseCode == 200) {
                setData(res.data.userList);
            }
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        getMyUser();
    }, []);


    return (
        <>
            <div className=" flex justify-center mb-4  ">
                <div className=" md:w-2/3 w-11/12 shadow-lg bg-white  ">
                    <div className="h-16  flex justify-center">
                        <div className=" grid grid-cols-3 px-5 flex justify-center content-center">
                            <div className="content-center flex">Employee goal list</div>
                            <div className=" flex justify-center "></div>
                            <div className="flex justify-end border-slate-500 outline-0 text-current">
                                <>
                                    <div className="relative ">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-1 pointer-events-none">
                                            <svg
                                                aria-hidden="true"
                                                className="w-5 h-5 text-gray-500 dark:text-gray-400"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                />
                                            </svg>
                                        </div>
                                        <input
                                            type="Search"
                                            placeholder="Search by name or email"
                                            className="outline-0 border-solid border border-sky-400 block w-full p-2 pl-10
       text-sm text-gray-900 rounded-lg bg-gray-50 
        dark:bg-gray-700
       dark:border-gray-600 dark:placeholder-gray-400 dark:text-white 
       dark:focus:ring-blue-500 dark:focus:border-blue-500 md:w-48 w-40"
                                            required
                                        />
                                    </div>
                                </>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {goaldata.map((item) => {
                return (
                    <div key={item.id} className="flex justify-center">
                        <div className="border-b-2 border-slate-500  md:w-2/3 w-11/12 text-center  shadow-lg bg-white hover:bg-sky-400" role="button">
                            <div className="grid grid-cols-2 gap-60  p-3 ">
                                <div onClick={() => {
                                    ViewGoal(item)
                                }}>{item.name}</div>
                                <div>

                                    <Menu as="div" className="relative inline-block md:text-left">
                                        <div className='ml-auto'>
                                            <Menu.Button >
                                                <BiDotsVerticalRounded className="text-current text-3xl" />
                                            </Menu.Button>
                                        </div>

                                        <Menu.Items className="absolute right-0 z-10 -mt-12 w-48  origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <div className="py-1">
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <a
                                                            onClick={() => {
                                                                ViewGoal(item)

                                                            }}
                                                            className={classNames(
                                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                                'block px-4 py-2 text-sm'
                                                            )}
                                                        >
                                                            View
                                                        </a>
                                                    )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <a
                                                            onClick={() => {
                                                                updateGoalName(item)
                                                            }}
                                                            className={classNames(
                                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                                'block px-4 py-2 text-sm'
                                                            )}
                                                        >
                                                            Edit
                                                        </a>
                                                    )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <a

                                                            onClick={() => {
                                                                deleteGoal(item)
                                                            }}
                                                            className={classNames(
                                                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                                'block px-4 py-2 text-sm'
                                                            )}
                                                        >
                                                            Delete
                                                        </a>
                                                    )}
                                                </Menu.Item>

                                            </div>
                                        </Menu.Items>
                                    </Menu>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default HOC(GoalListByCompany);